import { render, staticRenderFns } from "./rechargeRecord.vue?vue&type=template&id=636c948e"
import script from "./rechargeRecord.vue?vue&type=script&lang=js"
export * from "./rechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./rechargeRecord.vue?vue&type=style&index=0&id=636c948e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports